import instance from '@apis/instance';
import { PrepaidCardImagesResponse, PrepaidCareImageResponse } from '@models/prepaidCard';

class PrepaidCardImageApi {
    static getPrepaidCardImages(): Promise<PrepaidCardImagesResponse> {
        return instance.get('/prepaid-card/images');
    }

    static getPrepaidCardImage(id: string): Promise<PrepaidCareImageResponse> {
        return instance.get(`/prepaid-card/image/${id}`);
    }
}

export default PrepaidCardImageApi;
